import React from "react";
import { FireIcon } from "../../../../images/icons/icons";

const CalorieIntakeAnalysis = ({ targetCalories, averageCalories, series }) => {
  const avgPct = targetCalories ? Math.min(100, Math.round((averageCalories / targetCalories) * 100)) : 0;
  return (
    <section className="tme-nutrition-analysis__calorie-analysis">
      <div className="tme-nutrition-analysis__section-header">
        <h4>Calorie Intake Analysis</h4>
        <div className="tme-nutrition-analysis__section-metric">
          {averageCalories} / {targetCalories} kcal
        </div>
      </div>
      <div className="tme-nutrition-analysis__subtext">Daily Average vs Target</div>
      <div className="tme-nutrition-analysis__progress tme-nutrition-analysis__progress--lg">
        <div className="tme-nutrition-analysis__progress-fill" style={{ width: `${avgPct}%` }} />
      </div>
      <div className="tme-nutrition-analysis__below-text">
        {targetCalories && averageCalories < targetCalories
          ? `Below target by ${100 - avgPct}%`
          : averageCalories > targetCalories
          ? `Above target by ${avgPct - 100}%`
          : "On target"}
      </div>
      <div className="tme-nutrition-analysis__day-grid">
        {series.map((d, i) => {
          const pct = targetCalories ? Math.min(100, Math.round((d.calories / targetCalories) * 100)) : 0;
          return (
            <div key={i} className="tme-nutrition-analysis__day-card">
              <div className="tme-nutrition-analysis__day-date">{d.date}</div>
              <div className="tme-nutrition-analysis__day-calories">
                {d.calories}
                <span className="tme-nutrition-analysis__target-icon">
              <FireIcon color="#ED3F27" />
            </span>
              </div>
              <div className="tme-nutrition-analysis__progress tme-nutrition-analysis__progress--sm">
                <div className="tme-nutrition-analysis__progress-fill" style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CalorieIntakeAnalysis;


